import React from "react";
import { Table, Form } from "antd";
import { connect } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import layout from "../../GlobalSettings/GlobalSettings";
import { Message, Button, Input } from "../../../../BP2Components";

const EditableContext = React.createContext();
const EditableRow = ({ form, index, ...props }) => (
   <EditableContext.Provider value={form}>
      <tr {...props} />
   </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
   state = {
      editing: false
   };

   toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
         if (editing) {
            this.input.focus();
         }
      });
   };

   save = (e) => {
      const { record, handleSave } = this.props;
      this.form.validateFields((error, values) => {
         if (error && error[e.currentTarget.id]) {
            return;
         }
         this.toggleEdit();
         handleSave({ ...record, ...values });
      });
   };

   renderCell = (form) => {
      this.form = form;
      const { children, dataIndex, record, linkTitleTranslationKey } = this.props;
      const { editing } = this.state;
      return editing ? (
         <Form.Item style={{ margin: 0 }}>
            {form.getFieldDecorator(dataIndex, {
               rules: [
                  {
                     required: true,
                     message: `${linkTitleTranslationKey} is required.`
                  }
               ],
               initialValue: record[dataIndex]
            })(
               <Input
                  // style={{ width: "400px" }}
                  ref={(node) => (this.input = node)}
                  onPressEnter={this.save}
                  onBlur={this.save}
               />
            )}
         </Form.Item>
      ) : (
         <div
            className="editable-cell-value-wrap"
            style={{ paddingRight: 24 }}
            onClick={this.toggleEdit}
         >
            {children}
         </div>
      );
   };

   render() {
      const { editable, dataIndex, title, record, index, handleSave, children, ...restProps } =
         this.props;
      return (
         <td {...restProps}>
            {editable ? (
               <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
            ) : (
               children
            )}
         </td>
      );
   }
}

class LinkWidget extends React.Component {
   constructor(props) {
      super(props);
      this.columns = [
         {
            title: <IntlMessages id="settings.linkTitleTranslationKey" />,
            dataIndex: "linkTitleTranslationKey",
            editable: true
         },
         {
            title: <IntlMessages id="settings.url" />,
            dataIndex: "url",
            editable: true
         },
         {
            title: <IntlMessages id="settings.operation" />,
            dataIndex: "operations",
            render: (text, record) =>
               this.state.links.length >= 1 ? (
                  <>
                     <Button
                        buttonType="link"
                        onClick={() => this.handleDelete(record)}
                        className="gx-mt-3"
                     >
                        <IntlMessages id="global.delete" />
                     </Button>
                  </>
               ) : null
         }
      ];
      const rows = [];
      const { value } = this.props;
      value.links.map((link) => {
         rows.push({
            key: value.links.indexOf(link),
            url: link.url,
            id: link.id,
            linkTitleTranslationKey: link.linkTitleTranslationKey
         });
         return null;
      });

      this.state = {
         name: value.name,
         id: value.id,
         links: rows,
         priority: value.priority,
         widgetKey: value.widgetKey,
         webKey: value.webKey,
         count: rows.length,
         linkWidgetTitleTranslationKey: value.linkWidgetTitleTranslationKey,
         ...value
      };
   }

   handleDelete = (record) => {
      const links = [...this.state.links];
      this.setState({
         links: links.filter((item) => item.key !== record.key)
      });
   };

   handleChangeInput = (name) => (value) => {
      this.setState({
         [name]: value
      });
   };

   handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
   };
   handleAdd = () => {
      const { count, links } = this.state;
      const newData = {
         key: count,
         id: Math.floor(Math.random() * 100000) + 1,
         linkTitleTranslationKey: "FAQ",
         priority: count + 1,
         url: "/faq"
      };
      this.setState({
         links: [...links, newData],
         count: count + 1
      });
   };

   handleSave = (row) => {
      const newData = [...this.state.links];
      const index = newData.findIndex((item) => row.key === item.key);
      const item = newData[index];
      newData.splice(index, 1, {
         ...item,
         ...row
      });
      this.setState({ links: newData });
   };
   handleSubmit = (e) => {
      e.preventDefault();
      this.props.setWidgetInSheetParams(this.state);
      //  this.props.editBackgroundSheet(this.state.backgroundColourHex);
   };
   confirmSave = () => {
      Message.success(<IntlMessages id="save.modal" />);
   };

   render() {
      const { links } = this.state;
      const { value } = this.props;
      const components = {
         body: {
            row: EditableFormRow,
            cell: EditableCell
         }
      };
      const columns = this.columns.map((col) => {
         if (!col.editable) {
            return col;
         }
         return {
            ...col,
            onCell: (record) => ({
               record,
               editable: col.editable,
               dataIndex: col.dataIndex,
               title: col.linkTitleTranslationKey,
               handleSave: this.handleSave
            })
         };
      });
      return (
         <div>
            <div className="padding-left-15">
               <Button onClick={this.handleAdd} buttonType="primary">
                  <IntlMessages id="settings.addNewLink" />
               </Button>
            </div>

            <Table
               components={components}
               rowClassName={() => "editable-row"}
               bordered
               dataSource={links}
               columns={columns}
               pagination={false}
            />
            <Form {...layout} className="gx-mt-2 gx-ml-3" onSubmit={this.handleSubmit}>
               <div>
                  <div>
                     <Form.Item
                        key="linkWidgetTitleTranslationKey"
                        label={<IntlMessages id="settings.linkWidgetTitleTranslationKey" />}
                     >
                        <Input
                           type="linkWidgetTitleTranslationKey"
                           name="linkWidgetTitleTranslationKey"
                           defaultValue={value.linkWidgetTitleTranslationKey}
                           onChange={this.handleChangeInput("linkWidgetTitleTranslationKey")}
                           //  style={{ width: "600px" }}
                        />
                     </Form.Item>
                     <Form.Item key="widgetKey" label={<IntlMessages id="settings.widgetKey" />}>
                        <Input
                           type="widgetKey"
                           name="widgetKey"
                           onChange={this.handleChange}
                           defaultValue={value.widgetKey}
                        />
                     </Form.Item>
                     <Form.Item key="webKey" label={<IntlMessages id="settings.webKey" />}>
                        <Input
                           type="webKey"
                           name="webKey"
                           onChange={this.handleChange}
                           defaultValue={value.webKey}
                        />
                     </Form.Item>
                  </div>
                     <Form.Item>
                        <Button
                           key="btn"
                           buttonType="primary"
                           htmlType="submit"
                           onClick={this.confirmSave}
                        >
                           <IntlMessages id="global.save" />
                        </Button>
                     </Form.Item>
               </div>
            </Form>
         </div>
      );
   }
}

export default connect(null, { setWidgetInSheetParams })(LinkWidget);
